// ============================================================
// ReportCustomer01 — รายงานลูกค้าที่โอนกรรมสิทธิ์แล้ว
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { loading, format_date, getStorage, replaceText } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

// รายงานลูกค้าที่โอนกรรมสิทธิ์แล้ว
async function report_customer_1(data) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  let array = data.map((item, index) => [
    { text: index + 1, alignment: "center" },
    { text: item.building || "-", alignment: "center" },
    { text: item.address_number || "-", alignment: "center" },
    { text: item.full_name || "-", alignment: "left" },
    { text: "โอนแล้ว", alignment: "center" },
    { text: item.transfer_date ? format_date(item.transfer_date) : "-", alignment: "center" },
    { text: "-", alignment: "left" },
  ]);

  const docDefinition = {
    content: [
      { text: `รายชื่อลูกค้าที่โอนกรรมสิทธิ์ห้องชุดแล้ว บันทึกโอนถึง วันที่ ${format_date(new Date(), "dd/mm/yyyy")}`, alignment: "center", fontSize: 18, bold: true },
      { text: getStorage("project_name") || "", alignment: "center", fontSize: 18, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["6%", "7%", "9%", "32%", "15%", "16%", "15%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "อาคาร", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ - สกุล", alignment: "center" },
              { text: "สถานะ", alignment: "center" },
              { text: "วันโอนกรรมสิทธิ์", alignment: "center" },
              { text: "หมายเหตุ", alignment: "center" },
            ],
            ...array,
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  openPdf(textDocDefinition, `รายชื่อลูกค้าที่โอนกรรมสิทธิ์ห้องชุดแล้ว บันทึกโอนถึง วันที่ ${new Date().toISOString()}.pdf`);
}

export { report_customer_1 };